<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card elevation="2">
          <v-card-title class="text-h5">
            Models
          </v-card-title>
          <v-card-text>
            TODO: add models
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ManageModels'
}
</script>
